import { AccountDetailsEventFlow, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackRequestHigherBidLimitClickedPayload = TrackingPayload & {
    eventFlow: AccountDetailsEventFlow;
};

const trackRequestHigherBidLimitClickedAnalytics = (payload: TrackRequestHigherBidLimitClickedPayload) => {
    track(TrackingEvents.Bidding.RequestHigherBidLimitClicked, payload);
};

export const useTrackRequestHigherBidLimitClickedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(() => {
        trackRequestHigherBidLimitClickedAnalytics({
            eventFlow: AccountDetailsEventFlow.Bidding,
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [pathname, url]);
};
